import createSetCurrentSailing from './setCurrentSailing';
import { currentSailingVar } from '../reactiveVariables';

const setCurrentSailing = createSetCurrentSailing(currentSailingVar);

export default setCurrentSailing;
